
import type { SVGProps } from 'react';
const SvgExpandMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#expand-more_svg__a)">
      <path fill="#263E6A" d="M16.59 8 12 12.58 7.41 8 6 9.41l6 6 6-6z" />
    </g>
    <defs>
      <clipPath id="expand-more_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExpandMore;
